// src/components/LogoutButton.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import toast from "react-hot-toast";

const API_URL = import.meta.env.VITE_API_URL;

export default function LogoutButton({ className = "" }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/logout`, {
        method: "POST",
        credentials: "include", // sends the session cookie
        headers: { "Content-Type": "application/json" },
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data?.message || "Logout failed");

      // 1. Clear local storage
      sessionStorage.removeItem("user_id");
      sessionStorage.removeItem("user_profile");

      // 2. Show success toast
      toast.success(data.message || "با موفقیت خارج شدید");

      // 3. Redirect
      navigate("/", { replace: true });
    } catch (err) {
      console.error("Logout error:", err);
      toast.error(err.message || "خطا در خروج");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={loading}
      className={`
        flex items-center gap-2 px-4 py-2 rounded-lg
        bg-red-600 hover:bg-red-700 text-white font-medium
        transition-colors disabled:opacity-60 disabled:cursor-not-allowed
        ${className}
      `}
    >
      {loading ? (
        <span className="animate-spin">Loading...</span>
      ) : (
        <>
          <LogOut className="w-4 h-4" />
          خروج
        </>
      )}
    </button>
  );
}
